import { render, staticRenderFns } from "./MusicHistory.vue?vue&type=template&id=58d43b64&scoped=true&"
import script from "./MusicHistory.vue?vue&type=script&lang=js&"
export * from "./MusicHistory.vue?vue&type=script&lang=js&"
import style0 from "./MusicHistory.vue?vue&type=style&index=0&id=58d43b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d43b64",
  null
  
)

export default component.exports